import React from "react";
import { Link } from "react-router-dom";

// Replaces the two bordered cards with a full-bleed split. Hovering one half
// widens it; the other recedes. On touch and narrow viewports the grid becomes
// two stacked full-width halves and the hover behaviour is dropped entirely --
// a hover effect that "sticks" after a tap is worse than none.
//
// Each half owns a ground colour rather than sitting on the page's: the point
// is that these are two different worlds meeting, and a shared background
// undoes that before the copy gets a chance.
//
// The two kickers are a matched pair and need to stay one. They were "I have a
// screen" / "I have an ad"; they are now both questions, because a question
// invites an answer where a statement just labels a column. Rewriting one
// without the other leaves the section reading as though only half of it was
// finished.
//
// The host half asks about a WALL, not a screen. "Have a screen?" only spoke
// to somebody who had already bought a display, which is almost nobody — the
// business we want reading this has a waiting room and an empty wall, and does
// not yet know that is the qualifying condition. Asking about the wall is what
// makes a salon owner realise the section is addressed to them.

const SIDES = [
    {
        key: "screen",
        kicker: "Got a wall?",
        title: "Put it to work.",
        body:
            "Turn unused wall space into a new revenue stream. Host a WallBurst " +
            "screen in your business and earn when advertisers book your location. " +
            "You approve everything that plays.",
        // Points at /waitlist, which no longer means "straight to a form": that
        // page now leads with the estimator and the form sits under it. So the
        // softer first step and the commitment are the same destination, and
        // this no longer has to choose between them. /estimate still exists as
        // its own page and is linked from How it works.
        cta: "Become a host",
        to: "/waitlist",
    },
    {
        key: "ad",
        kicker: "Got something to say?",
        // "your business" was narrower than the question above it and narrower
        // than the hero, which offers this to a business, an event or a
        // person. "It" refers back to the kicker and covers all three.
        title: "Put it where people already are.",
        body:
            "Browse locations near you, see the rate up front, and book by the " +
            "hour or the day across as many screens as you need.",
        cta: "Explore locations",
        to: "/devices",
    },
];

export default function TwoSides() {
    return (
        <section className="ts" aria-label="Two sides, one marketplace">
            {SIDES.map((side) => (
                <Link to={side.to} className={"ts__half ts__half--" + side.key} key={side.key}>
                    <span className="ts__art" aria-hidden="true">
                        <span className="ts__art-screen" />
                        <span className="ts__art-screen" />
                        <span className="ts__art-screen" />
                    </span>

                    <span className="ts__body">
                        <span className="ts__kicker">{side.kicker}</span>
                        <span className="ts__title">{side.title}</span>
                        <span className="ts__text">{side.body}</span>
                        <span className="ts__cta">
                            {side.cta}
                            <svg viewBox="0 0 20 12" width="20" height="12" aria-hidden="true">
                                <path d="M0 6h17M12 1l5 5-5 5" fill="none" stroke="currentColor"
                                      strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </span>
                    </span>
                </Link>
            ))}
        </section>
    );
}
